import { render, staticRenderFns } from "./Conduct.vue?vue&type=template&id=4505d0d8&"
import script from "./Conduct.vue?vue&type=script&lang=js&"
export * from "./Conduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports